import styled from '@emotion/styled';
import { breakpoints, spacing } from '@naf/theme';
import { Typography } from '@naf-simba/building-blocks-typography';
import { simbaStyled } from '@naf-simba/theme';

export const ConsentWrapper = styled.div<{ hidden?: boolean }>`
  margin-top: ${spacing.space40};
  display: ${(props) => (props.hidden ? 'none' : 'flex')};
  flex-direction: column;
`;

export const ConsentTextWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: ${spacing.space4};
`;

export const ConsentTextContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  margin-right: ${spacing.space32};
`;

export const ReadMoreButtonWrapperDesktop = styled.div`
  display: flex;
  align-self: flex-start;

  @media (max-width: ${breakpoints.m}) {
    display: none;
  }
`;

export const ReadMoreButtonMobileDesktop = styled.div`
  display: none;
  align-self: flex-start;
  margin-top: ${spacing.space4};
  margin-bottom: ${spacing.space4};

  @media (max-width: ${breakpoints.m}) {
    display: grid;
  }
`;

export const ConsentStatementText = simbaStyled(Typography)(({ theme }) => ({
  '&&': {
    marginBottom: theme.spacing('xs'),
  },
}));

export const ConsentHelpText = simbaStyled(Typography)(({ theme }) => ({
  '&&': {
    marginTop: theme.spacing('m'),
  },
}));
